var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mw-hide"},[_c('img',{staticStyle:{"border":"0"},attrs:{"src":_vm.piwikUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }